import React from "react";

import { useTranslation } from "react-i18next";
import {
	FrontendUserInfo,
	FrontendOrder,
	FrontendCompanyWithAdditionalInfomation,
} from "node-library/dist/portal";
import AdminOrderCell from "./AdminOrderCell";

interface Props {
	company: FrontendCompanyWithAdditionalInfomation;
	orders: Array<FrontendOrder>;
	user: FrontendUserInfo | undefined;

	// sortBy: OrderTableSortColumn;
	// setSortBy: React.Dispatch<React.SetStateAction<OrderTableSortColumn>>;
	// sortOrder: SortOrder;
	// setSortOrder: React.Dispatch<React.SetStateAction<SortOrder>>;
	deleteOrder: (order: FrontendOrder) => void;

	goToViewOrderDetails: (order: FrontendOrder) => void;
	viewOrderCOC: (order: FrontendOrder) => void;

	setDiscardOrderConfirmOpen: React.Dispatch<React.SetStateAction<boolean>>;
	setProceedAction: React.Dispatch<React.SetStateAction<() => void>>;
}

export default function AdminViewOrdersTableGridView(props: Props) {
	const { t: translation } = useTranslation();

	const {
		company,
		orders,
		// sortBy,
		// setSortBy,
		// sortOrder,
		// setSortOrder,
		deleteOrder,
		goToViewOrderDetails,
		viewOrderCOC,
		setDiscardOrderConfirmOpen,
		setProceedAction,
	} = props;

	const sampleCells: Array<React.ReactNode> = orders
		? orders.map((order: FrontendOrder, index: number) => {
				return (
					<AdminOrderCell
						key={order.orderId}
						order={order}
						user={props.user}
						viewOrderCOC={() => {
							viewOrderCOC(order);
						}}
						goToViewOrderDetails={() => goToViewOrderDetails(order)}
						deleteOrder={() => {
							setProceedAction(() => () => deleteOrder(order));
							setDiscardOrderConfirmOpen(true);
						}}
					/>
				);
		  })
		: [];

	return <div className="view-order-grid-table">{sampleCells}</div>;
}
